import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import { Search, AlertCircle, Loader2 } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PCodesPage = () => {
  const { token } = useAuth();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/pcodes/stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setStats(r.data)).catch(() => {});
  }, [token]);

  const search = async () => {
    if (!query.trim()) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API}/pcodes/search?q=${encodeURIComponent(query)}&limit=50`, { headers: { Authorization: `Bearer ${token}` } });
      setResults(res.data.codes || []);
      setTotal(res.data.total || 0);
    } catch { }
    setLoading(false);
  };

  const handleKey = (e) => { if (e.key === 'Enter') search(); };

  return (
    <Layout>
      <div className="max-w-3xl mx-auto" data-testid="pcodes-page">
        <h1 className="font-heading text-3xl font-bold text-white mb-2">CODIGOS DE ERROR (DTC)</h1>
        <p className="text-zinc-400 mb-6">
          {stats ? `${stats.total.toLocaleString()} codigos OBD-II` : 'Cargando...'} — Busca por codigo o descripcion
        </p>

        <div className="bg-surface border border-white/10 rounded-md p-4 mb-6">
          <div className="flex gap-3">
            <Input placeholder="Ej: P0300, P0171, fuel pressure..." value={query} onChange={e => setQuery(e.target.value)}
              onKeyDown={handleKey} className="bg-surface-highlight border-white/10 text-white flex-1" data-testid="pcode-search-input" />
            <Button onClick={search} disabled={loading || !query.trim()} className="bg-primary hover:bg-primary/90 font-heading uppercase" data-testid="pcode-search-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Search className="w-4 h-4 mr-2" /> Buscar</>}
            </Button>
          </div>
        </div>

        {results.length > 0 && (
          <div className="bg-surface border border-white/10 rounded-md overflow-hidden">
            <div className="px-4 py-2 border-b border-white/10 text-zinc-500 text-xs">
              {total > 50 ? `Mostrando 50 de ${total.toLocaleString()} resultados` : `${total} resultados`}
            </div>
            <div className="divide-y divide-white/5" data-testid="pcode-results">
              {results.map((p, i) => (
                <div key={i} className="px-4 py-3 hover:bg-white/[0.02] transition-colors flex items-start gap-3">
                  <span className="text-primary font-mono font-bold text-sm bg-primary/10 px-2 py-1 rounded flex-shrink-0">{p.code}</span>
                  <span className="text-zinc-300 text-sm">{p.description}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {!loading && results.length === 0 && query && total === 0 && (
          <div className="bg-surface border border-white/10 rounded-md p-8 text-center">
            <AlertCircle className="w-8 h-8 text-zinc-600 mx-auto mb-3" />
            <p className="text-zinc-400">No se encontraron codigos para "{query}"</p>
          </div>
        )}

        {!query && (
          <div className="bg-surface border border-white/10 rounded-md p-12 text-center">
            <AlertCircle className="w-12 h-12 text-zinc-600 mx-auto mb-4" />
            <p className="text-zinc-400">Introduce un codigo DTC o descripcion para buscar</p>
            <p className="text-zinc-600 text-xs mt-2">Ejemplo: P0300, P0171, fuel, misfire, injection...</p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default PCodesPage;
